'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerOfferColumns = renderWithRef('BannerOfferColumns', null, (n, o)=>{
    let { children: s } = n;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-banner-offer-columns'
        ],
        props: n,
        children: s
    });
});

export { BannerOfferColumns };
